import { kaia } from "./theme_kaia";
import { novasense } from "./theme_novasense";
import { kraftanmelding } from "./theme_kraftanmelding";
import { typography_kaia } from "./typography_kaia";
import { typography_novasense } from "./typography_novasense";
import { typography_kraftanmelding } from "./typography_kraftanmelding";

// Extend the Window interface to include APP_BRAND
declare global {
  interface Window {
    APP_BRAND?: string;
  }
}

export const brands = {
  kaia: {
    theme: kaia,
    typography: typography_kaia,
    logo: "images/KaiaOriginalLogo.svg",
    domains: ["stage-test.kaiasolutions.no", "portal.kaiasolutions.no"],
    header: "Kaia Portal",
    whiteLabellingHeader: false,
  },
  novasense: {
    theme: novasense,
    typography: typography_novasense,
    logo: "images/novasense_logo_horisontal.svg",
    domains: ["stage-test.novasense.ch", "portal.novasense.ch"],
    header: "Novasense Portal",
    whiteLabellingHeader: true,
  },
  kraftanmelding: {
    theme: kraftanmelding,
    typography: typography_kraftanmelding,
    logo: "@images/kraftanmelding_logo_horisontal.png",
    domains: [
      "stage-test.kraftanmelding.no",
      "portal.kraftanmelding.no",
      "stage-test.captiva.no",
      "portal.captiva.no",
    ],
    header: "Kraftanmelding Portal",
    whiteLabellingHeader: false,
  },
};

function getQueryParam(name: string): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

export function detectBrand(): string {
  // Prefer the server-provided brand if available
  if (window.APP_BRAND && brands[window.APP_BRAND]) {
    return window.APP_BRAND;
  }

  const host = window.location.hostname;

  if (host === "localhost" || host === "[::1]" || host === "127.0.0.1") {
    const queryBrand = getQueryParam("brand");
    return queryBrand ?? "kaia";
  }
  return "kaia";
}
